import React, { useEffect, useState } from 'react';

const Meets = () => {
  window.location.href = 'https://clearword.com';
};

export default Meets 
